module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading":"Loading..."},"zhHant":{"loading":"讀取中..."},"ja":{"loading":"読み込み中…"},"ko":{"loading":"불러오는 중…"}}')
  delete Component.options._Ctor
}
